import './index.scss';
import { lang } from '@umu/ukit-lang';
import { UmuInput, UmuSelect } from '@umu/umu-design';
import React from 'react';
import { getScoreList } from '../../dataFlow';
interface IScoreRangeInfo {
    startValue: string;
    startLabel: string;
    endValue: string;
    numberDefault?: string;
    endLabel: string;
}
interface IProps {
    info: IScoreRangeInfo;
    placeholder?: [string, string];
    onChange: (data: keyof IScoreRangeInfo, value: string) => void;
}

const validateUndefinedString = (value: string, defaultVal = '') => {
    const strVal = String(value);
    if (strVal === 'undefined' || strVal === 'null') {
        return defaultVal;
    }
    return value;
};

const ScoreRange = (props: IProps) => {
    const { info, placeholder = [lang('请输入标签（选填）'), lang('请输入标签（选填）')], onChange } = props;
    return (
        <div className="multi-capability-question-score-info">
            <div className="score-info-zone">
                <span className="before_label">{lang('从')}:</span>
                <UmuSelect
                    className="score"
                    value={validateUndefinedString(info.startValue, '1')}
                    width="0.8rem"
                    options={getScoreList(9, 0)}
                    onChange={(value) => onChange('startValue', value)}
                />
                <UmuInput
                    value={validateUndefinedString(info.startLabel)}
                    onChange={({ value }) => onChange('startLabel', value)}
                    expandConfig={{ placeholder: placeholder[0] }}
                />
            </div>
            <div className="score-info-zone">
                <span className="before_label">{lang('到')}:</span>
                <UmuSelect
                    className="score"
                    width="0.8rem"
                    value={validateUndefinedString(info.endValue, '5')}
                    options={getScoreList(10)}
                    onChange={(value) => onChange('endValue', value)}
                />
                <UmuInput
                    value={validateUndefinedString(info.endLabel)}
                    onChange={({ value }) => onChange('endLabel', value)}
                    expandConfig={{ placeholder: placeholder[1] }}
                />
            </div>
        </div>
    );
};
export { ScoreRange, IScoreRangeInfo };
